import { ProcessesIndexRoute } from "@/routes/processes/processes-route";
import HTZRoute from "@/routes/processes/[processId]/htz/htz-route";
import { htzRoutes } from "@/routes/processes/[processId]/htz/htz-routes";
import RLTRoute from "@/routes/processes/[processId]/rlt/rlt";
import { rltRoutes } from "@/routes/processes/[processId]/rlt/rlt-routes";
import VBSRoute from "@/routes/processes/[processId]/vbs/vbs";
import { vbsRoutes } from "@/routes/processes/[processId]/vbs/vbs-routes";

export const processesRoutes = [
  {
    index: true,
    element: <ProcessesIndexRoute />,
  },
  {
    path: "htz/:processId",
    element: <HTZRoute />,
    children: htzRoutes,
  },
  {
    path: "rlt/:processId",
    element: <RLTRoute />,
    children: rltRoutes,
  },
  {
    path: "vbs/:processId",
    element: <VBSRoute />,
    children: vbsRoutes,
  },
];
